require('/src/com/yext/listingslaunchstorm/js/components/styles/subheader.module.scss.module.css');

export const mainText = "_main-text_cz9su_1";
export const extraText = "_extra-text_cz9su_1";
export const subHeader = "_sub-header_cz9su_1";
